/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheExportGapPrestationDto } from './FcbRechercheExportGapPrestationDto';
import {
    FcbRechercheExportGapPrestationDtoFromJSON,
    FcbRechercheExportGapPrestationDtoFromJSONTyped,
    FcbRechercheExportGapPrestationDtoToJSON,
} from './FcbRechercheExportGapPrestationDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheExportGapPrestationDtoPaginatedResults
 */
export interface FcbRechercheExportGapPrestationDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheExportGapPrestationDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheExportGapPrestationDto>}
     * @memberof FcbRechercheExportGapPrestationDtoPaginatedResults
     */
    results?: Array<FcbRechercheExportGapPrestationDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheExportGapPrestationDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheExportGapPrestationDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheExportGapPrestationDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheExportGapPrestationDtoPaginatedResultsFromJSON(json: any): FcbRechercheExportGapPrestationDtoPaginatedResults {
    return FcbRechercheExportGapPrestationDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheExportGapPrestationDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheExportGapPrestationDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheExportGapPrestationDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheExportGapPrestationDtoPaginatedResultsToJSON(value?: FcbRechercheExportGapPrestationDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheExportGapPrestationDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

